<script lang="ts">
	import { format } from 'svelte-i18n';
	//Design system components
	import { Toggle } from '@Shelly/shelly-design-system';
	//Helpers
	import { gen2Request } from 'src/services/gen_2_http_reqs';
	import { onSettingsResponse } from 'src/helpers/device_settings_helpers';
	//Types
	import type { Device } from 'src/types/Device';
	import type { SettingRequest } from 'src/types/requests/settings/setting';
	import type { VCInterfaceStatus } from 'src/types/VirtualComponents';

	let className = '';
	export { className as class };

	export let device: Device;
	export let status: VCInterfaceStatus;
	export let title: string = '';

	let targetLock = false;
	let waitForResponse = false;
	let value = status?.event;

	const onStatusChange = (status: VCInterfaceStatus) => {
		let _value = status?.event;
		if (!waitForResponse && !targetLock && value !== _value) {
			value = _value;
		}
		if (targetLock && value == _value) {
			targetLock = false;
		}
	};

	const saveValue = async () => {
		const _value = !value;
		waitForResponse = true;
		let res: SettingRequest;
		res = await gen2Request(device, `${status.vcType}.set`, {
			id: status.id,
			value: _value,
		});
		if (res?.isok) {
			targetLock = true;
			value = _value;
		}
		onSettingsResponse(res, device);
		waitForResponse = false;
	};

	$: onStatusChange(status);
</script>

{#if status?.id}
	<Toggle
		size="m"
		aria-label={$format('option_action_toggle', { default: 'Toggle' })}
		class={className}
		disabled={waitForResponse}
		checked={value}
		on:click={saveValue}
		id="toggle-o23fmoq"
	>
		{title}
	</Toggle>
{/if}
